import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'unity-card',
  templateUrl: './unity-card.component.html',
  styleUrls: ['./unity-card.component.scss']
})
export class UnityCardComponent implements OnInit {
  @Input() isMetric: Boolean = false;
  @Input() label: string = null;
  @Input() stat: string = null;
  @Input() desc: string = null;
  @Input() icon: string = null;
  @Input() progress: any = null;
  @Input() panelColor: string = null;
  @Input() iconColor: string = null;
  @Input() title: string = null;
  @Input() subtitle: string = null;
  @Input() count: any = null;
  @Input()
  badgeColor: string = null;

  get statusBadgeColor() {
    return this.badgeColor;
  }

  @Output() onDblClick = new EventEmitter<any>();
  @Input()
  allowCollapse: boolean = false;

  @Input()
  collapsed: boolean = false;

  @Input()
  iconSecondary: string = ''; //secondary icon to the right of title -- used for special indicators

  @Input()
  iconSecondaryTooltip: string = null; //tool tip for secondary icon to the right of title

  customColor: string = null;

  constructor() {}

  ngOnInit(): void {}

  convertColors() {
    if (this.panelColor) {
      switch (this.panelColor.toUpperCase()) {
        case '#B3E6B3':
          return 'status-success';
        case '#FF9999':
          return 'status-error';
        case '#FFEB99':
          return 'status-warning';
        case '#CCCCCC':
          return 'status-info';
        default:
          return (this.customColor = this.panelColor);
      }
    }
  }

  onDoubleClick() {
    this.onDblClick.emit();
  }
}
